import _ from 'lodash';
import BakeasyTextField, { BakeasyTextFieldProps } from '../textfields/BakeasyTextField';
import { t } from 'i18next';
import * as Regex from '../../constants/Regex';
function BakeasyTextFieldUsername(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      label={t('USERNAME')}
      type="text"
      name="username"
      placeHolder={t('ENTER_YOUR_USERNAME')}
      required={props?.required}
      value={props?.value}
      maxLength={30}
      disabled={props?.disabled}
      onChange={props?.onChange}
    />
  );
}

export default BakeasyTextFieldUsername;

export function BakeasyTextFieldEmailId(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      type="email"
      name="email"
      required={true}
      value={props?.value}
      regexPattern={Regex.emailId}
      maxLength={30}
      label={t('EMAIL_ID')}
      placeHolder={t('ENTER') + _.toLower(t('EMAIL_ID'))}
      onChange={props?.onChange}
    />
  );
}
